export const accent = '#f90000';
export const text = '#121212';
export const primary = '#121212';
export const secondary = '#d1a19d';
export const tertiary = '#f3f3f3';
export const highlight = '#5b8bf7';
export const ceramic = '#C3CDE6';
